import React from 'react';

import { CaseOverviewTabContent } from '../case-overview-tab-content';

export const Case2OverviewTabContent = React.memo(() => {
  return (
    <CaseOverviewTabContent
      title={'Predictive Network Service Operations'}
      description={
        'Transforming network operations to achieve superior customer experience with an approach of data-driven operations using AI and automation to become more predictive, proactive and efficient. This approach results in improvements like shorter time to restoration, fewer incidents, less truck rolls and the removal of events that would have degraded service performance.'
      }
      assetType={'case2'}
    />
  );
});
